<template>
  <router-view></router-view>
</template>

<script>
import { onMounted } from "vue";
import { useStore } from "vuex";

export default {
  name: "App",
  setup() {
    const store = useStore();

    // 开始请求值
    onMounted(() => {
      store.dispatch("getInit");
    });
  },
};
</script>

<style>
body {
  background-color: #f3f4f5;
}
#app {
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  overflow: hidden;
  min-height: 100vh;
  background-color: #ffffff;
}
</style>
